import React from 'react';
import { Link } from 'react-router-dom';
import { companyData } from '../data';
import ScrollReveal from './ScrollReveal';

export default function About() {
  const { title, subtitle, paragraphs, bullets } = companyData.about;
  const projectImage = "https://assets.auxodev.dk/assets/39491458-c5e4-4280-8295-09ca3e3ec516/1f501778-72bf-46d1-ab94-5b171a85b464.jpg";

  return (
    <section id="om-os" className="py-20 md:py-28 bg-white border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {/* Left Column: Image */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <ScrollReveal direction="left" duration={800}>
              <div className="overflow-hidden border border-gray-200 shadow-lg">
                <img
                  src={projectImage}
                  alt="Udført arbejde af Bust Byg & Renovering"
                  className="w-full h-[400px] md:h-[500px] lg:h-[550px] object-cover object-center"
                />
              </div>
            </ScrollReveal>
          </div>

          {/* Right Column: Text Content */}
          <div className="lg:col-span-6 space-y-6 order-1 lg:order-2">
            <ScrollReveal direction="right" duration={800} delay={100} className="space-y-6">
              <div className="space-y-2">
                <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight uppercase">
                  {title}
                </h2>
                <p className="text-lg font-semibold text-gray-700">
                  {subtitle}
                </p>
              </div>

              <div className="space-y-4 text-gray-600 text-base leading-relaxed">
                {paragraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>

              {/* CTA Button to Subpage */}
              <div className="pt-6 border-t border-gray-200">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-none text-base font-bold uppercase tracking-wider transition-all duration-200"
                >
                  <span>Kontakt os i dag</span>
                </Link>
              </div>
            </ScrollReveal>
          </div>

        </div>
      </div>
    </section>
  );
}
